import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styles from './PlayedVideoCallToAction.module.scss';
import { useTranslation } from 'react-i18next';
import { CustomButton } from '../../../../components/Button/Button';
import CloseButton from '../../../../components/CloseButton/CloseButton';
import VormatsAPI from '../../../../../common/apis/VormatsAPI';
import { isEmailFormatValid } from '../../../../utils/stringHelper';
import { Field, Form, Formik } from 'formik';
import cx from 'classnames';
import { ToastNotification } from '../../../../components/Toast/Toast';
import { useUIContext } from '../../../../context/UIContext';

function validateEmail(value) {
  let error;
  if (!value) {
    error = 'my_video.end_video.cta.required_filed';
  } else if (!isEmailFormatValid(value)) {
    error = 'my_video.end_video.cta.invalid_email';
  }
  return error;
}

const PlayedVideoCallToAction = ({ storyId }) => {
  const [email, setEmail] = useState('');
  const [showContent, setShowContent] = useState(false);
  const [loading, setLoading] = useState(false);
  const isMessageAlreadyShown = useMemo(() => Boolean(localStorage.getItem('end-cta-closed')), []);

  const { isMobileView } = useUIContext();

  const { t } = useTranslation();

  const handleEmailChange = e => {
    setEmail(e.target.value);
  };

  const handleHideMessage = () => {
    localStorage.setItem('end-cta-closed', true);
    setShowContent(false);
  };

  const handleSendEmail = useCallback(async () => {
    setLoading(true);
    try {
      // Send email to API
      await VormatsAPI.sendNewEmail(email, storyId);
      handleHideMessage();
      ToastNotification({ message: t('my_video.end_video.cta.email_successfully_sent'), iconName: 'success', isMobileView });
    } catch (e) {
      console.error(e);
      ToastNotification({ message: t('video.protected_modal.error.something_went_wrong'), isMobileView });
    } finally {
      setLoading(false);
    }
  }, [email]);

  useEffect(() => {
    if (!isMessageAlreadyShown) {
      setShowContent(true);
    }
  }, []);

  if (isMessageAlreadyShown) {
    return null;
  }

  return (
    <div className={cx(styles.wrapper, { [styles.showContent]: showContent })}>
      <CloseButton className={styles.closeBtn} onClose={handleHideMessage} />
      <div className={styles.content}>
        <p>{t('my_video.end_video.cta.message')}</p>
        <Formik
          initialValues={{
            email: '',
          }}
        >
          {({ errors, touched }) => (
            <Form className={styles.formContainer} onChange={handleEmailChange}>
              <div className={styles.inputWrapper}>
                <Field
                  name="email"
                  validate={validateEmail}
                  className={cx(styles.input, { [styles.invalid]: errors.email && touched.email })}
                  placeholder={t('general.email')}
                />
                <div className={cx(styles.invalidError, { [styles.showError]: errors.email && touched.email })}>{t(errors.email)}</div>
              </div>

              <CustomButton
                variant="primary"
                onClick={handleSendEmail}
                label={t('storyboard.steps.submit')}
                className={styles.bookBtn}
                loading={loading}
                loadingSpinner={true}
                loadingText={false}
                disabled={errors?.email || !email}
              />
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default PlayedVideoCallToAction;
